import { Typography } from "@mui/material";

export const CustomTemplateStatusCell = ({ params }: any) => {
  return (params.row.isDraft ?
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: "#F3F3F3",
        color: "#676767",
        padding: "2px 8px",
        borderRadius: "6px",
        "&:nth-of-type(2n)": {
          marginLeft: "4px",
        },
      }}
    >
          Draft
    </Typography>
    :
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: "#FFF8FA",
        color: "#BF295C",
        padding: "2px 8px",
        borderRadius: "6px",
        "&:nth-of-type(2n)": {
          marginLeft: "4px",
        },
      }}
    >
          Completed
    </Typography>
  )
};